import type { PdfiumExports as E } from "@pdfking/pdfium"

export type WasmExports = {
  [E.memory]: WebAssembly.Memory
  [E.malloc]: (size: number) => number
  [E.free]: (ptr: number) => void
  [E.__indirect_function_table]: WebAssembly.Table
  [E.__wasm_call_ctors]: () => void
  [E.setThrew]: (a: number, b: number) => void
  [E.emscripten_stack_get_current]: () => number
  [E._emscripten_stack_restore]: (sp: number) => void
  [E.FPDF_InitLibrary]: () => void
  [key: string]: unknown
}
